function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import * as React from 'react';
import { usePortalContainer } from '../../lib/portal-container-context';
import { cn } from '../../lib/utils';
import { buttonVariants } from './button';
function AlertDialog(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(AlertDialogPrimitive.Root, _object_spread({
        "data-slot": "alert-dialog"
    }, props));
}
function AlertDialogTrigger(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(AlertDialogPrimitive.Trigger, _object_spread({
        "data-slot": "alert-dialog-trigger"
    }, props));
}
function AlertDialogPortal(_0) {
    let {} = _0, props = _extends({}, _0);
    const portalContainer = usePortalContainer();
    return /*#__PURE__*/ _jsx(AlertDialogPrimitive.Portal, _object_spread({
        container: portalContainer !== null && portalContainer !== void 0 ? portalContainer : undefined,
        "data-slot": "alert-dialog-portal"
    }, props));
}
function AlertDialogOverlay(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(AlertDialogPrimitive.Overlay, _object_spread({
        "data-slot": "alert-dialog-overlay",
        className: cn('data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50', className)
    }, props));
}
function AlertDialogContent(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsxs(AlertDialogPortal, {
        children: [
            /*#__PURE__*/ _jsx(AlertDialogOverlay, {}),
            /*#__PURE__*/ _jsx(AlertDialogPrimitive.Content, _object_spread({
                "data-slot": "alert-dialog-content",
                className: cn('bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg', className)
            }, props))
        ]
    });
}
function AlertDialogHeader(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        "data-slot": "alert-dialog-header",
        className: cn('flex flex-col gap-2 text-center sm:text-left', className)
    }, props));
}
function AlertDialogFooter(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        "data-slot": "alert-dialog-footer",
        className: cn('flex flex-col-reverse gap-2 sm:flex-row sm:justify-end', className)
    }, props));
}
function AlertDialogTitle(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(AlertDialogPrimitive.Title, _object_spread({
        "data-slot": "alert-dialog-title",
        className: cn('text-lg font-semibold', className)
    }, props));
}
function AlertDialogDescription(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(AlertDialogPrimitive.Description, _object_spread({
        "data-slot": "alert-dialog-description",
        className: cn('text-muted-foreground text-sm', className)
    }, props));
}
function AlertDialogAction(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(AlertDialogPrimitive.Action, _object_spread({
        className: cn(buttonVariants(), className)
    }, props));
}
function AlertDialogCancel(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(AlertDialogPrimitive.Cancel, _object_spread({
        className: cn(buttonVariants({
            variant: 'outline'
        }), className)
    }, props));
}
export { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertDialogPortal, AlertDialogTitle, AlertDialogTrigger };
